import { render, staticRenderFns } from "./fccFinalizaVagas.vue?vue&type=template&id=85aeee52"
import script from "./fccFinalizaVagas.vue?vue&type=script&lang=js"
export * from "./fccFinalizaVagas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports